import AuditListState from "../types/AuditListState";

export default function createAuditListState(): AuditListState {
    return {
        audits: {},
    };
}